import Home from '../pages/Home';
import Style from '../pages/Style';
import Contact from '../pages/Contact';
import Services from '../pages/Services';
import Items from '../pages/Items';
import Details from '../pages/Details';
import Moodboards from '../pages/Moodboards';

const routes = [
  {
    path: '/',
    component: Home,
    exact: true,
    public: true,
  },
  {
    path: '/style',
    label: 'Il mio stile',
    component: Style,
    exact: false,
    public: true
  },
  {
    path: '/moodboards',
    label: 'Moodboards',
    component: Moodboards,
    exact: false,
    public: false
  },
  {
    path: '/progetti',
    label: 'Progetti',
    component: Items,
    exact: false,
    public: true
  },
  {
    path: '/servizi',
    label: 'Servizi',
    component: Services,
    exact: false,
    public: true
  },
  {
    path: '/design',
    label: 'Design',
    component: Items,
    exact: false,
    public: false
  },
  {
    path: '/details/:type/:id',
    label: null,
    component: Details,
    exact: false,
    public: true
  },
  {
    path: '/contatti',
    label: 'Contatti',
    component: Contact,
    exact: false,
    public: true
  }
];

export default routes;
